import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AdminSidebar from "./components/Sidebar";
import Header from "./components/Header";
import "../../css/admin/addPatient.scss";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/clinet";

interface Props {}
const AddPatient: React.FC<Props> = (Props) => {
  let history = useNavigate();
  const initialValues = {
    name: "",
    fatherName: "",
    patientId: 0,
    phoneNumber: 0,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().min(3, "کوتاه است").max(15).required(),
    fatherName: Yup.string().min(3, "کوتاه است").max(15),
    patientId: Yup.string().min(4).max(20).required(),
    phoneNumber: Yup.string().min(4).max(20).required(),
  });

  interface ISubmitedData {
    name: string;
    fatherName: string;
    patientId: number;
    phoneNumber: number;
  }

  const onSubmit = (data: ISubmitedData) => {
    try {
      apiClient.post("/patients", data).then(() => {
        history("../Admin/PatientsList");
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="addPatientPage">
      <AdminSidebar />

      <div className="leftColumnPatients">
        <Header />
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form className="formContainerCrud">
            <label className="crudLabel">:اسم</label>
            <ErrorMessage name="name" component="span" />
            <Field
              autoComplete="off"
              id="inputCreatePost"
              name="name"
              placeholder="(Ex. John123...)"
            />
            <label className="crudLabel" style={{ display: "block" }}>
              اسم پدر:
            </label>
            <ErrorMessage name="fatherName" component="span" />
            <Field
              autoComplete="off"
              id="inputCreatePost"
              name="fatherName"
              placeholder="(Ex. John123...)"
            />

            <label className="crudLabel">کد ملی:</label>
            <ErrorMessage name="patientId" component="span" />
            <Field
              autoComplete="off"
              type="number"
              id="inputCreatePost"
              name="patientId"
              placeholder="Your patientId..."
            />
            <label className="crudLabel">شماره تلفن</label>
            <ErrorMessage name="phoneNumber" component="span" />
            <Field
              autoComplete="off"
              type="number"
              id="inputCreatePost"
              name="phoneNumber"
              placeholder="Your phoneNumber..."
            />

            <button type="submit" className="SubmitButton">
              {" "}
              Add Patient
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default AddPatient;
